const ERROR_MSGS = {
  en: {
    chatStartError:
      "Failed to generate AI response. Please close the session and try again.",
    transcriptError:
      "Failed to generate transcript. Please try again.",
  },
  ar: {
    chatStartError:
      "فشل توليد الاستجابة من الذكاء الاصطناعي. يرجى إغلاق الجلسة والمحاولة مرة أخرى.",
    transcriptError:
      "فشل توليد الترجمة. يرجى المحاولة مرة أخرى.",
  },
};

export default ERROR_MSGS;
